module.exports = __webpack_public_path__ + "static/media/cup-icon.176c29d9.svg";